/* GODS & KINGS continuous motion fixes. */
(function(){
  function installMarquees(root){
    (root||document).querySelectorAll('marquee-component').forEach(function(m){
      if(m.dataset.gkContinuous==='1')return;
      var wrapper=m.querySelector('.marquee__wrapper');
      var content=m.querySelector('.marquee__content');
      if(!wrapper||!content)return;
      m.dataset.gkContinuous='1';
      wrapper.getAnimations().forEach(function(a){a.cancel()});
      var base=content.cloneNode(true);base.removeAttribute('ref');
      var track=document.createElement('div');track.className='gk-continuous-marquee-track';
      for(var i=0;i<4;i++){var seq=base.cloneNode(true);seq.classList.add('gk-continuous-sequence');if(i>0)seq.setAttribute('aria-hidden','true');track.appendChild(seq)}
      wrapper.replaceChildren(track);
      requestAnimationFrame(function(){var first=track.firstElementChild;if(!first)return;var distance=first.getBoundingClientRect().width;track.style.setProperty('--gk-marquee-distance',distance+'px');var factor=Number(m.getAttribute('data-speed-factor'))||20;var seconds=Math.max(18,(distance/Math.max(m.clientWidth,1))*factor);track.style.setProperty('--gk-marquee-duration',seconds+'s');track.classList.add('gk-marquee-running')});
    });
  }
  function installStandardsRail(root){
    (root||document).querySelectorAll('.gk-standard-rail').forEach(function(rail){
      var track=rail.querySelector('.gk-standard-track');if(!track||track.dataset.gkGapless==='1')return;
      var first=track.querySelector('.gk-standard-set');if(!first)return;
      track.dataset.gkGapless='1';
      track.getAnimations().forEach(function(a){a.cancel()});
      /* Rebuild from one canonical set so there can be no hidden spacer or delayed copy. */
      var canonical=first.cloneNode(true);canonical.removeAttribute('aria-hidden');track.replaceChildren();
      for(var i=0;i<5;i++){var copy=canonical.cloneNode(true);if(i>0)copy.setAttribute('aria-hidden','true');track.appendChild(copy)}
      requestAnimationFrame(function(){
        var set=track.firstElementChild;if(!set)return;
        var distance=set.getBoundingClientRect().width;
        if(!distance)return;
        /* Exact one-set translation: copy 2 occupies copy 1's position at the loop boundary. */
        var pxPerSecond=55;
        var duration=Math.max(12000,(distance/pxPerSecond)*1000);
        var anim=track.animate([{transform:'translate3d(0,0,0)'},{transform:'translate3d(-'+distance+'px,0,0)'}],{duration:duration,iterations:Infinity,easing:'linear'});
        track._gkGaplessAnimation=anim;
      });
    });
  }
  function install(root){installMarquees(root);installStandardsRail(root)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){install(document)});else install(document);
  document.addEventListener('shopify:section:load',function(e){install(e.target)});
  window.addEventListener('resize',function(){document.querySelectorAll('.gk-standard-track[data-gk-gapless="1"]').forEach(function(t){if(t._gkGaplessAnimation)t._gkGaplessAnimation.cancel();t.removeAttribute('data-gk-gapless')});installStandardsRail(document)});
})();
